<script>
import { mapGetters } from 'vuex'
import ApiProcessor from '@lib/processors/api-processor'
import VersionTabTable from './product-versions-tab.table.js'
import getExportedFilename from '@lib/utils/get-exported-filename'

export default {
  name: 'ProductVersionsTab',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      table: VersionTabTable(this),
    }
  },
  computed: {
    ...mapGetters('me', [
      'showProductVersionDetails',
    ]),
    listeners() {
      if (this.showProductVersionDetails) {
        return {
          'row-click': this.onRowClick,
        }
      }

      return {}
    },
  },
  created() {
    // this.getVersions()
  },
  methods: {
    getVersions() {
      this.table.processor = new ApiProcessor({
        component: this,
        path: `products/${this.product.id}/versions`,
        disableQueryString: true,
      })
    },
    onRowClick(row) {
      this.$router.push({
        name: 'product-version',
        params: {
          id: this.product.id,
          versionId: row.id,
        },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <table-layout
    v-if="table.processor"
    table-name="product-versions"
    :processor="table.processor"
    :filters="table.filters"
    :columns="table.columns"
    :fragments="false"
    :export-filename="getExportedFilename"
    v-on="listeners"
  />
</template>
